<template>
    <div class="ui secondary menu">
        <div class="item logoimagedesktop" style="padding-left: 0px; margin-left: 0px;">
            <img id="PROMSERVICESLOGO" src='img/logos/sso7.png' style="width: 60px;">
            <a style="margin-left: 20px; color: white;"><h3 style="font-family: 'MuseoSans300', normal !important;">{{usersplit}}</h3></a>
        </div>
        <div class="right menu">
            <div onclick="$('#SIDEBAR').sidebar('toggle');" style="cursor:pointer; margin-top: 25px; margin-left: 10px;">
                <div class="ui big label" style="background-color: rgba(0,0,0,0) !important">
                     <div class="detail" style="margin-left: 2px;" v-on:click='settings'><i class="cogs inverted icon" ></i></div>
                </div>
                
                <div class="ui big label" style="background-color: rgba(0,0,0,0) !important">
                     <div class="detail" style="margin-left: 2px;" v-on:click='logout'><i class="sign out alternate inverted icon"></i></div>
                </div>
            </div>
        </div>
    </div>	
</template>

<script>
import router from '../router'

const $ = require('jquery')
window.$ = $

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
	props: ['imagelogin'],
	name: 'servicemenu',
	data: function () {
		return {
			user: '',
			usersplit: ''
		}
	},
	methods: {
		logout: function () {
			$.getJSON(this.baseUrl + "/logout").done(function(  ) {
				router.push('/')
			}.bind(this))
		},
		settings: function () {
			$('.ui.modal').modal('show')
		}
	},
	mounted: function () {
        $.post(this.baseUrl + "/isauth", function(data) { 
            if (data["response"] == true) {
                this.user = data["user"]; 
				let splittted = this.user.split('.')
				splittted.forEach(function (s) {
					this.usersplit += capitalizeFirstLetter(s) + " "
				}.bind(this))
            }     
        }.bind(this)); 
	}
}

</script>